import { useEffect } from 'react';

import { appActions } from 'app/app.actions';
import { useAppDispatch } from 'utils/redux/useAppDispatch';

export type IntelligenceConversationEvents = {
  /**
   * Preview a conversation.
   *
   * @param arg.id The numeric conversation ID.
   */
  'conversation:preview': (arg: { id: number }) => void;
};

export const useIntelligenceConversationEvents = (): void => {
  const dispatch = useAppDispatch();

  useEffect(() => {
    if (typeof window === 'undefined') return;
    const { appEvents } = window._intelligence;

    appEvents.on('conversation:preview', ({ id }) => {
      if (!id) return;

      dispatch(
        appActions.showModal({
          modal: {
            type: 'app:conversationPreview',
            arg: { csid: id },
          },
        }),
      );
    });
  }, [dispatch]);
};
